import { HomeVariant } from '../shared/types';
import * as Base from './base';
import * as WithFAQs from './withFAQs';

export const HomeVariants = {
    [HomeVariant.BASE]: Base.Home,
    [HomeVariant.WITH_FAQS]: WithFAQs.Home,
};
